import { ErrorMessage } from "formik";


export function CustomErrorMessage({name, className, component} : {name: string, className?: string, component?: string}) {


    return(
        <ErrorMessage className={`text-sm text-red-500 ${className}`} name={name} component={component ?? "div"} />
    )


}